import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ForgotUserPasswordRequest, UsersService } from '@src/app/shared/backend/clients';
import { firstValueFrom } from 'rxjs';

@Component({
	selector: 'app-reset-password',
  standalone: false,
	templateUrl: './reset-password.component.html',
	styleUrls: ['./reset-password.component.scss'],
	host: {
		class: 'app-reset-password'
	}
})
export class ResetPasswordComponent implements OnInit {

  formSubmitted: boolean = false;
  successMessage: string = '';
  errorMessage: string = '';

  public resetPasswordFormGroup: FormGroup = this.fb.group({
    username: ['', [Validators.required]],
  });

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private usersService: UsersService
  ) { }

  ngOnInit(): void { }

  async resetPassword() {
    if (this.resetPasswordFormGroup.valid) {
      this.formSubmitted = true;

      const username = this.resetPasswordFormGroup.get('username')?.value;
      const payload: ForgotUserPasswordRequest = {
        username
      };

      await firstValueFrom(this.usersService.apiUsersForgotPasswordPut(payload));
    }
  }

  submitOnPressEnter(event: any) {
    if (event.keyCode === 13) {
      this.resetPassword();
    }
  }

  backToLogin() {
    this.router.navigate(['/login']);
  }
}
